import { ReactNode } from 'react';
import IconButton from '@mui/material/IconButton';
import { SxProps } from '@mui/material/styles';

export interface ActionButtonProps {
	onClick: () => void;
	icon: ReactNode;
	disabled?: boolean;
	sx?: SxProps;
	testId?: string;
}

const ActionButton = ({ onClick, icon, disabled = false, sx, testId = 'action-button' }: ActionButtonProps) => {
	return (
		<IconButton
			disabled={disabled}
			onClick={onClick}
			data-testid={testId}
			sx={{ borderRadius: '50%', border: '1px solid', padding: '3px', ...sx }}
		>
			{icon}
		</IconButton>
	);
};

export default ActionButton;
